import React from "react";
import bg from "../../svgs/roadmap/bg.svg";

export default function DesktopContainer() {
  return (
      <div className="w-[1420px] h-[1130px] relative lg:block hidden">
        <img src={bg} alt="bg" className="absolute top-0 left-0 " />

        <div className="absolute font-Red-Undead text-8xl font-bold left-[52%] top-4">
          1
        </div>
        <div className="absolute top-40 left-[52%]">
          Develop Beta game
          <br />
          Create token
          <br />
          Make strategic partnerships
          <br />
          Develop website
        </div>
        <div className="absolute top-[290px] left-[54%] text-[40px] font-bold">
          PHASE
        </div>

        <div className="bg-[#05FF00] absolute bottom-32 left-[35%] h-[80px] w-[80px] bg-opacity-50 blur-[100px] " />

        <div className="absolute font-Red-Undead text-8xl font-bold left-48 top-52">
          2
        </div>
        <div className="absolute top-[350px] left-16">
          Community building
          <br />
          Partnership With Hulk Calls
          <br />
          Launch of the beta game for public
          <br />
          Create the PURGE ARMY
          <br />
          Game characters go live on the BSC <br />
          network and will give access to the game.
        </div>
        <div className="absolute top-[530px] left-16 text-[40px] font-bold">
          PHASE
        </div>

        <div className="absolute font-Red-Undead text-8xl font-bold right-96 top-[460px]">
          3
        </div>
        <div className="absolute right-10 top-[54%]">
          Partnership with Pinksale and their team
          <br />
          Open presale
          <br />
          Game activities and giveaways
          <br />
          Partnerships with NFT marketplaces and communities
          <br />
          Staking protocol for passive income on $PURGE
        </div>
        <div className="absolute right-20 top-[67%] text-[40px] font-bold">
          PHASE
        </div>

        <div className="absolute font-Red-Undead text-8xl font-bold left-[380px] bottom-[280px]">
          4
        </div>
        <div className="absolute left-[380px] bottom-[110px]">
          Token launch
          <br />
          Development of new in-game characters
          <br />
          Grow the PURGE army
          <br />
          Public leaderboard
          <br />
          Partnerships with other gaming communities
        </div>
        <div className="absolute left-[39%] bottom-0 text-[40px] font-bold">
          PHASE
        </div>
      </div>
  );
}
